import { createContext, useState } from "react";
import { useDispatch } from "react-redux";

import { toastErrorMessage } from "../../utils/toastMessage/toastMessage";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../redux/actions/loadingActions/loadingActions";

import { setUserAction } from "../../redux/actions/userActions/userActions";
import { loginService } from "../../services/userServices";

export const authContext = createContext({
  phoneNumber: "",
  setPhoneNumber: () => {},
  password: "",
  setPassword: () => {},
  handleLogIn: () => {},
});

const AuthContext = ({ children }) => {
  const dispatch = useDispatch();

  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");

  // Handle Log In
  const handleLogIn = async (event) => {
    event?.preventDefault();

    const objData = {
      phoneNumber,
      password,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { data, status } = await loginService(objData);
      if (status === 200) {
        dispatch(setUserAction(data.result?.accessToken));
        window.location.reload();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <authContext.Provider
      value={{
        phoneNumber,
        setPhoneNumber,
        password,
        setPassword,
        handleLogIn,
      }}
    >
      {children}
    </authContext.Provider>
  );
};

export default AuthContext;
